module.exports = __webpack_public_path__ + "static/media/expeditedssl.eae6313c.svg";